export const technologiesData = [
    {
        "id": 1,
        "name": "HTML5",
    },
    {
        "id": 2,
        "name": "CSS3",
    },
    {
        "id": 3,
        "name": "Javascript",
    },
    {
        "id": 4,
        "name": "React",
    },
    {
        "id": 5,
        "name": "Mobx",
    },
    {
        "id": 6,
        "name": "AngularJS",
    },
    {
        "id": 7,
        "name": "ASP.NET",
    },
    {
        "id": 8,
        "name": "Typescript",
    },
    {
        "id": 9,
        "name": "Amazon S3",
    },
    {
        "id": 10,
        "name": "Microsoft Azure",
    },
    {
        "id": 11,
        "name": "Microsoft SQL",
    },
    {
        "id": 12,
        "name": "iOS",
    },
    {
        "id": 13,
        "name": "Android",
    },
    {
        "id": 14,
        "name": "C",
    },
    {
        "id": 15,
        "name": "Ruby",
    },
    {
        "id": 16,
        "name": "PHP",
    },
    {
        "id": 17,
        "name": "MySQL",
    },
    {
        "id": 18,
        "name": "Wordpress",
    },
    {
        "id": 19,
        "name": "Xamarin",
    },
    {
        "id": 20,
        "name": "PostgreSQL",
    },
    {
        "id": 21,
        "name": "Raspberry Pi",
    },
    {
        "id": 22,
        "name": "P25",
    },
    {
        "id": 23,
        "name": "SQLite",
    },
    {
        "id": 24,
        "name": "ArcGIS",
    },
    {
        "id": 25,
        "name": "Oracle",
    },
    {
        "id": 26,
        "name": "C++",
    },
    {
        "id": 27,
        "name": "ASP.NET Core",
    }
];

export default technologiesData;
